// src/mocks/mockImports.js
// -----------------------------------------------------------------------------
// Dummy seed data for local development only.  Imported by ProcessosPage when
// the app detects it is running on localhost.  Feel free to tweak or extend.
// -----------------------------------------------------------------------------
export const MOCK_IMPORTS = [
  {
    referencia: "REF-0001",
    di: "DI-20250101-01",
    bu: "BU‑A",
    poso: "PO‑1001",
    regime: "Drawback",
    modal: "Marítimo",
    etd: "2025-04-01",
    eta: "2025-05-14",
    descricao: "Rolamentos industriais",
    active: true,
  },
  {
    referencia: "REF-0002",
    di: "DI-20250103-02",
    bu: "BU‑B",
    poso: "SO‑2002",
    regime: "Repetro",
    modal: "Aéreo",
    etd: "2025-04-05",
    eta: "2025-04-15",
    descricao: "Peças de turbina",
    active: false,
  },
  {
    referencia: "REF-0003",
    di: "DI-20250105-03",
    bu: "BU‑C",
    poso: "PO‑1003",
    regime: "Admissão Temporária",
    modal: "Rodoviário",
    etd: "2025-03-28",
    eta: "2025-04-02",
    descricao: "Ferramentas de corte",
    active: true,
  },
  {
    referencia: "REF-0004",
    di: "DI-20250107-04",
    bu: "BU‑A",
    poso: "SO‑2004",
    regime: "Ex‑Tarifário",
    modal: "Ferroviário",
    etd: "2025-04-10",
    eta: "2025-04-20",
    descricao: "Componentes eletrônicos",
    active: true,
  },
  {
    referencia: "REF-0005",
    di: "DI-20250109-05",
    bu: "BU‑D",
    poso: "PO‑1005",
    regime: "Importação Definitiva",
    modal: "Marítimo",
    etd: "2025-04-12",
    eta: "2025-05-01",
    descricao: "Cabos de aço",
    active: false,
  },
  {
    referencia: "REF-0006",
    di: "DI-20250111-06",
    bu: "BU‑E",
    poso: "SO‑2006",
    regime: "Drawback",
    modal: "Aéreo",
    etd: "2025-04-15",
    eta: "2025-04-22",
    descricao: "Sensor óptico",
    active: true,
  },
  {
    referencia: "REF-0007",
    di: "DI-20250113-07",
    bu: "BU‑C",
    poso: "PO‑1007",
    regime: "Repetro",
    modal: "Rodoviário",
    etd: "2025-04-18",
    eta: "2025-04-25",
    descricao: "Válvulas hidráulicas",
    active: false,
  },
  {
    referencia: "REF-0008",
    di: "DI-20250115-08",
    bu: "BU‑B",
    poso: "SO‑2008",
    regime: "Admissão Temporária",
    modal: "Marítimo",
    etd: "2025-04-20",
    eta: "2025-05-05",
    descricao: "Telas de proteção",
    active: true,
  },
  {
    referencia: "REF-0009",
    di: "DI-20250117-09",
    bu: "BU‑E",
    poso: "PO‑1009",
    regime: "Ex‑Tarifário",
    modal: "Ferroviário",
    etd: "2025-04-22",
    eta: "2025-05-02",
    descricao: "Motores elétricos",
    active: true,
  },
  {
    referencia: "REF-0010",
    di: "DI-20250119-10",
    bu: "BU‑D",
    poso: "SO‑2010",
    regime: "Importação Definitiva",
    modal: "Aéreo",
    etd: "2025-04-25",
    eta: "2025-04-30",
    descricao: "Equipamentos de segurança",
    active: false,
  },
];
